import { useEffect, useState } from 'react';

import TextArea from 'components/field/TextArea';
import FormItem from 'components/form/FormItem';
import ContextMenu from 'components/global/ContextMenu';

import useAccessControl from 'hooks/useAccessControl';

const ContentCreator = ({
	fieldName = 'context',
	label = 'content',
	menuItems,
	isLoading,
	disabled = false,
	colSpan = {
		md: 12
	}
}) => {
	const isAuthorized = useAccessControl();
	const [textAreaRef, setTextAreaRef] = useState(null);
	const [isContextMenuOpen, setIsContextMenuOpen] = useState(false);
	const [anchorPoint, setAnchorPoint] = useState({ x: 0, y: 0 });
	const [selectedContextMenuRow, setSelectedContextMenuRow] = useState(null);
	const [dummyMenuItems, setDummyMenuItems] = useState(null);

	//* * Helpers
	const handleInsertText = (input) => {
		const curPos = textAreaRef.selectionStart;

		const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
			window.HTMLTextAreaElement.prototype,
			'value'
		).set;

		const value = textAreaRef.value;

		nativeInputValueSetter.call(textAreaRef, value.slice(0, curPos) + input + value.slice(curPos));

		const inputEvent = new Event('input', { bubbles: true });
		textAreaRef.dispatchEvent(inputEvent);
	};

	const handleOnContextMenu = (event) => {
		event.preventDefault();
		event.stopPropagation();
		if (event.pageX) {
			setAnchorPoint({ x: event.pageX, y: event.pageY });
		} else {
			const curPos = textAreaRef?.selectionStart;
			const { left, top } = textAreaRef.getBoundingClientRect();
			const { offsetWidth, offsetHeight } = textAreaRef;
			const { offsetLeft, offsetTop } = textAreaRef;
			const { scrollLeft, scrollTop } = textAreaRef;
			const { clientWidth, clientHeight } = textAreaRef;

			const pagex = Math.min(
				left + offsetLeft + scrollLeft + (curPos * offsetWidth) / clientWidth,
				window?.innerWidth - 20
			);
			const pagey = Math.min(top + offsetTop + scrollTop + offsetHeight / clientHeight, window?.innerHeight - 20);

			setAnchorPoint({ x: pagex, y: pagey });
		}

		setSelectedContextMenuRow(menuItems);
		setIsContextMenuOpen(true);
	};

	//* * EFFECTS
	useEffect(() => {
		const newMenuItems = menuItems.map((item) => ({
			...item,
			action: () => {
				handleInsertText(item.input);
			}
		}));
		setDummyMenuItems(newMenuItems);
		setSelectedContextMenuRow(newMenuItems);
	}, [menuItems, textAreaRef]);

	useEffect(() => {
		if (textAreaRef && menuItems) {
			textAreaRef.addEventListener('keydown', (e) => {
				if (e.key === '/') {
					handleOnContextMenu(e);
				}
			});
		}
	}, [textAreaRef, menuItems]);

	return (
		<FormItem label={label} colSpan={colSpan} isLoading={isLoading} required>
			<TextArea
				ref={setTextAreaRef}
				name={fieldName}
				disabled={isAuthorized('SMSModule') === false || disabled}
				placeholder="smsContent.placeholder"
				// description={templates.find((x) => smsType === x.smsType)?.smsKeywords}
				onContextMenu={handleOnContextMenu}
			/>

			{menuItems && isContextMenuOpen && (
				<ContextMenu
					menuItems={dummyMenuItems}
					row={selectedContextMenuRow}
					anchorPoint={anchorPoint}
					onClose={() => {
						setIsContextMenuOpen(false);
					}}
					isContextMenuOpen={isContextMenuOpen}
					setIsContextMenuOpen={setIsContextMenuOpen}
				/>
			)}
		</FormItem>
	);
};

export default ContentCreator;
